// extracted by mini-css-extract-plugin
export default {"etherServingAuto":"styles_etherServingAuto__VhCvJ","leftSide":"styles_leftSide__HJIej","icon":"styles_icon__hlwJR","time":"styles_time__azk4I"};